import { colors } from '../../../../../packages';

export const sx = {
  drawer: {
    '& .MuiDrawer-paper': {
      width: '480px !important',
      boxSizing: 'border-box !important',
    },
  },
  wrapper: {
    display: 'flex !important',
    flexDirection: 'column !important',
    height: '100% !important',
  },
  header: {
    display: 'flex !important',
    justifyContent: 'space-between !important',
    alignItems: 'center !important',
    padding: '24px !important',
    borderBottom: `1px solid ${colors.neutral100} !important`,
  },
  headerTitle: {
    fontSize: '20px !important',
    fontWeight: '600 !important',
  },
  backBtn: {
    padding: '0 !important',
  },
  form: {
    height: '100% !important',
    '& form': {
      flex: '1 !important',
      display: 'flex !important',
      flexDirection: 'column !important',
      height: '100% !important',
    },
  },
  formContent: {
    flex: '1 !important',
    padding: '24px !important',
    overflowY: 'auto !important',
  },
  section: {
    marginBottom: '24px !important',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px !important',
  },
  sectionTitle: {
    fontSize: '16px !important',
    fontWeight: '600 !important',
  },
  valuesInput: {
    marginBottom: '8px !important',
  },
  objectiveItem: {
    display: 'flex !important',
    gap: '8px !important',
  },
  removeObjective: {
    padding: '0 !important',
    color: `${colors.destructive500} !important`,
  },
  addObjective: {
    fontSize: '14px !important',
    color: `${colors.primary500} !important`,
    '& svg': {
      width: '18px !important',
      marginRight: '6px !important',
      '& path': {
        fill: colors.primary500,
      },
    },
  },
  removeContentBtn: {
    fontSize: '14px !important',
    color: `${colors.destructive500} !important`,
    '& svg': {
      width: '18px !important',
      marginRight: '6px !important',
      '& path': {
        fill: colors.destructive500,
      },
    },
  },
  footer: {
    display: 'flex !important',
    justifyContent: 'space-between !important',
    gap: '16px !important',
    padding: '24px !important',
    borderTop: `1px solid ${colors.neutral100} !important`,
  },
};
